// bd-n3yqb / bd-deepcontext-b4zw — load the blueprint → owning-job map whenever a
// create/edit form opens, so the picker can disable blueprints already owned by
// another job. Extracted from ScheduledJobs.tsx unchanged.
import { useEffect, useState } from "react";
import type { BlueprintUsageMap } from "../PromptMultiSelect";
import { scheduledJobsApi } from "./api";

export function useBlueprintUsage(isFormOpen: boolean): BlueprintUsageMap {
  const [blueprintUsage, setBlueprintUsage] = useState<BlueprintUsageMap>({});

  useEffect(() => {
    if (!isFormOpen) return;
    let cancelled = false;
    scheduledJobsApi
      .getBlueprintUsage()
      .then((usage) => {
        if (!cancelled) setBlueprintUsage(usage);
      })
      .catch((err) => {
        // Non-fatal: picker just won't disable anything; backend 409 still backstops.
        console.error("Failed to load blueprint usage:", err);
      });
    return () => {
      cancelled = true;
    };
  }, [isFormOpen]);

  return blueprintUsage;
}
